import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function PainPoints() {
  return <section className="bg-white pb-20 px-6" data-id="element-232">
      <div className="max-w-[680px] mx-auto" data-id="element-233">
        <FadeIn data-id="element-234">
          <p className="text-lg text-[#1B2A4A]/80 mb-8" data-id="element-235">
            Porque si estás aquí, probablemente estás viviendo una versión de
            esto:
          </p>

          <div className="space-y-6 pl-6 border-l-4 border-[#F5A623]/30" data-id="element-236">
            <div className="relative" data-id="element-237">
              <p className="text-lg text-[#1B2A4A] italic" data-id="element-238">
                "Alguien te dijo 'cada niño a su ritmo'… pero tu intuición no se
                calma."
              </p>
            </div>
            <div className="relative" data-id="element-239">
              <p className="text-lg text-[#1B2A4A] italic" data-id="element-240">
                "Buscaste 'señales de autismo 18 meses' y saliste peor que
                entraste."
              </p>
            </div>
            <div className="relative" data-id="element-241">
              <p className="text-lg text-[#1B2A4A] italic" data-id="element-242">
                "Intentaste 'probar' cosas (mírame / señala / di mamá) y tu hijo
                se cerró."
              </p>
            </div>
            <div className="relative" data-id="element-243">
              <p className="text-lg text-[#1B2A4A] italic" data-id="element-244">
                "Te da miedo hablarlo en voz alta porque suena a etiqueta…"
              </p>
            </div>
          </div>

          <div className="mt-10 text-center" data-id="element-245">
            <p className="text-xl font-medium text-[#1B2A4A] mb-2" data-id="element-246">
              Pero también te da miedo no hacer nada y arrepentirte.
            </p>
            <p className="text-lg text-[#1B2A4A]/70" data-id="element-247">Ese es el punto.</p>
            <div className="mt-8 p-6 bg-[#1B2A4A] text-white rounded-xl shadow-lg" data-id="element-248">
              <p className="font-serif text-2xl text-center" data-id="element-249">
                No necesitas más información. <br data-id="element-250" />
                <span className="text-[#3BBFAD]" data-id="element-251">Necesitas una ruta.</span>
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}